import { BehaviorSubject, Subject, from } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import getInlineHelpContentService from "../services/inlineHelpContent";
export var inlineHelpContentAction$ = new Subject();
var inlineHelpContentPayloadStore$ = new BehaviorSubject({
    pageId: ""
});
export var inlineHelpContentStore$ = new BehaviorSubject({});
inlineHelpContentAction$.subscribe(inlineHelpContentPayloadStore$);
inlineHelpContentAction$.pipe(switchMap(function(param) {
    var pageId = param.pageId;
    return getInlineHelpContentService({
        pageId: pageId
    }).pipe(map(function(param) {
        var inlineHelpContent = param.inlineHelpContent;
        return {
            response: inlineHelpContent
        };
    }), catchError(function(err) {
        return from([
            {
                error: err
            }
        ]);
    }));
})).subscribe(inlineHelpContentStore$);
export function resetContentStore() {
    inlineHelpContentStore$.next({});
}
inlineHelpContentStore$.subscribe(function(param) {
    var error = param.error;
    if (!error) {
        // eslint-disable-next-line no-useless-return
        return;
    }
// TODO: implement notification for failed request
});

//# sourceMappingURL=inlineHelpContentStore.js.map